import * as React from "react";
import styled from "styled-components";
import DOMPurify from "dompurify";

export function InfoCard({ title, content }) {
  const sanitizedDescription = DOMPurify.sanitize(content);

  return (
    <CardContainer className="info-card">
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent dangerouslySetInnerHTML={{ __html: sanitizedDescription }} />
    </CardContainer>
  );
}

const CardContainer = styled.div`
  border-radius: var(--border-radius);
  background: var(--card-gradient);
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 35px;
  position: relative;
  box-shadow: var(--card-shadow);
  border: 1px solid rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(5px);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  overflow: hidden;

  &:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 5px;
    top: 0;
    left: 0;
    background: linear-gradient(90deg, var(--primary-color), var(--secondary-color));
    opacity: 0.8;
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: var(--card-hover-shadow);
  }

  @media (max-width: 991px) {
    padding: 30px 25px;
  }
`;

const CardHeader = styled.div`
  position: relative;
  margin-bottom: 20px;
`;

const CardTitle = styled.h2`
  color: var(--text-color);
  font-size: 32px;
  font-weight: 700;
  line-height: 1.3;
  margin-bottom: 5px;
  position: relative;
  display: inline-block;
`;

const CardContent = styled.div`
  color: var(--light-text);
  font-size: 16px;
  font-weight: 400;
  line-height: 1.7;
  
  .span-bold {
    color: var(--primary-color);
    font-weight: 700;
  }
  
  .span-dark {
    color: var(--text-color);
    font-weight: 500;
  }
  
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;
